export default __webpack_public_path__ + "static/media/SENAIT_NL_SEQ13.489f0945.mp3";